export const IMG_CND_URL = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

export const ITEM_IMG_CDN_URL = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";

export const FETCH_MENU_URL = "https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=23.2599333&lng=77.412615&restaurantId="
// "https://corsanywhere.herokuapp.com/https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=23.2599333&lng=77.412615&restaurantId="
// "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=23.2599333&lng=77.412615&restaurantId="

// shimmer Menu card unit
export const shimmer_menu_card_unit = 4;


// array of restaurant list
const restaurantList = [
    {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        type: "restaurant",
        data: {
            type: "F",
            id: "68758",
            name: "Nath'S Chinese",
            uuid: "dd9db611-ba85-488d-b018-16f2f92bccb7",
            city: "22",
            area: "Hathibarkala Salwala",
            totalRatingsString: "10000+ ratings",
            cloudinaryImageId: "u1rmf2otdajyddgiztam",
            cuisines: ["North Indian", "Chinese"],
            tags: [],
            costForTwo: 12500,
            costForTwoString: "₹125 FOR TWO",
            deliveryTime: 46,
            minDeliveryTime: 46,
            maxDeliveryTime: 46,
            slaString: "46 MINS",
            lastMileTravel: 7.599999904632568,
            slugs: {
                restaurant: "naths-chinese-hathibarkala-salwala-hathibarkala",
                city: "dehradun",
            },
            cityState: "22",
            address: "Radha Plaza, Opp Silvercity, Rajpur Road, Dehradun",
            locality: "Rajpur Road",
            parentId: 13608,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "60% off",
                shortDescriptionList: [
                    {
                        meta: "60% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "60% off up to ₹120 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "60% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "60% off up to ₹120 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            ribbon: [
                {
                    type: "PROMOTED",
                },
            ],
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID:
                "cid=5807584~p=16~eid=00000186-4021-dab8-2f08-00a4004e100c",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "7.5 kms",
            hasSurge: false,
            sla: {
                restaurantId: "68758",
                deliveryTime: 46,
                minDeliveryTime: 46,
                maxDeliveryTime: 46,
                lastMileTravel: 7.599999904632568,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: true,
            avgRating: "3.9",
            totalRatings: 10000,
            new: false,
        },
        subtype: "basic",

        parentWidget: false,
    },
    {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        type: "restaurant",
        data: {
            type: "F",
            id: "556208",
            name: "Garden Of Taste",
            uuid: "13ea5ec9-271c-4947-b4c9-390800b4226b",
            city: "22",
            area: "Dharampur",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "fecd5efhbte7y7ygg9qw",
            cuisines: ["Indian", "Chinese", "Tandoor"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 0.699999988079071,
            slugs: {
                restaurant: "garden-of-taste-dharampur-dharampur",
                city: "dehradun",
            },
            cityState: "22",
            address:
                "06 No. Puliya Dobhal Chowk Dehradun, Raipur Range, Dehradun Rural, Dehradun, Uttarakhand",
            locality: "Puliya Dobhal Chowk",
            parentId: 334564,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.6 kms",
            hasSurge: false,
            sla: {
                restaurantId: "556208",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 0.699999988079071,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "--",
            totalRatings: 0,
            new: false,
        },
        subtype: "basic",

        parentWidget: false,
    },
    {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",

        type: "restaurant",
        data: {
            type: "F",
            id: "556205",
            name: "Got Kitchen",
            uuid: "665ef7a4-9096-4cbc-828f-e1acf1a8d22a",
            city: "22",
            area: "Chukkuwala",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "h9kky28fw7dkzvwmohez",
            cuisines: ["North Indian", "Chinese", "Tandoor"],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "₹250 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 0.699999988079071,
            slugs: {
                restaurant: "got-kitchen-dharampur-dharampur",
                city: "dehradun",
            },
            cityState: "22",
            address:
                "06 No. Puliya Dobhal Chowk Dehradun, Raipur Range, Dehradun Rural, Dehradun, Uttarakhand",
            locality: "Puliya Dobhal Chowk",
            parentId: 334554,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.6 kms",
            hasSurge: false,
            sla: {
                restaurantId: "556205",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 0.699999988079071,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "--",
            totalRatings: 0,
            new: false,
        },
        subtype: "basic",

        parentWidget: false,
    },
    {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",

        type: "restaurant",
        data: {
            type: "F",
            id: "653176",
            name: "Da Mexican Pizza",
            uuid: "308d491c-b94f-4608-8f11-4c45a74eb3d4",
            city: "22",
            area: "Karanpur",
            totalRatingsString: "20+ ratings",
            cloudinaryImageId: "3c05148485899456142a4d19d4ef2895",
            cuisines: ["Pizzas", "Burgers", "Pastas", "Fast Food"],
            tags: [],
            costForTwo: 20000,
            costForTwoString: "₹200 FOR TWO",
            deliveryTime: 41,
            minDeliveryTime: 41,
            maxDeliveryTime: 41,
            slaString: "41 MINS",
            lastMileTravel: 5.800000190734863,
            slugs: {
                restaurant: "da-mexican-pizza-hathibarkala-hathibarkala-2",
                city: "dehradun",
            },
            cityState: "22",
            address:
                "72 KARANPUR ,,Dehradun Nagar Nigam,Dehradun,Uttarakhand-248001",
            locality: "Dehradun Nagar Nigam",
            parentId: 67423,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "60% off",
                shortDescriptionList: [
                    {
                        meta: "60% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "60% off up to ₹120 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "60% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "60% off up to ₹120 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                headerType: 0,
                subHeader: "",
                superFreedel: "",
            },
            ribbon: [
                {
                    type: "PROMOTED",
                },
            ],
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID:
                "cid=5908194~p=19~eid=00000186-4021-dab8-2f08-00a5004e1368",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "5.8 kms",
            hasSurge: false,
            sla: {
                restaurantId: "653176",
                deliveryTime: 41,
                minDeliveryTime: 41,
                maxDeliveryTime: 41,
                lastMileTravel: 5.800000190734863,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: true,
            avgRating: "3.4",
            totalRatings: 20,
            new: true,
        },
        subtype: "basic",

        parentWidget: false,
    },
];

export default restaurantList;